<template>
  <div class="schedule-wrapper">
    <div class="schedule__pop__block">
      <ScheduleRow
        v-for="(schedule, index) in schedules"
        :key="'schedule_' + index"
        :schedule="schedule"
        @goToDetails="goToDetailsHandler(schedule)"
      />
    </div>
  </div>
</template>

<script>
import ScheduleRow from '@/components/popup/schedule-row';
import { mapActions, mapGetters } from 'vuex';
import { PopupPage } from '@/utils/index.model';

export default {
  components: {
    ScheduleRow,
  },
  mounted() {
    this.updateSchedules();
  },
  computed: {
    ...mapGetters('schedule', ['schedules']),
    ...mapGetters('general', ['timezone']),
  },
  methods: {
    ...mapActions('schedule', ['updateSchedule', 'updateSchedules']),
    ...mapActions('menu', ['updateMenu']),
    goToDetailsHandler(schedule) {
      if (!schedule.imageUrl) return;
      this.updateSchedule(schedule);
      this.updateMenu({ isPopupOpen: true, activePopupPage: PopupPage.scheduleDetail });
    },
    renderDateTime(value, action) {
      const newValue = new Date(value);

      switch (action) {
        case 'date':
          return this.$moment(newValue).tz(this.timezone).format('DD/MM/YYYY');
        case 'time':
          return this.$moment(newValue).tz(this.timezone).format('HH:mm:ss');
        default:
          return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-wrapper {
  height: 100%;
}
.schedule__pop__block {
  width: 100%;
  box-sizing: border-box;
  margin: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}
</style>
